@if (items && items.length === 0) {
	<empty-state
		data-test="no-woundcare-available"
		icon="med-icon md-band_aid"
		message="{{ 'wound_care.empty_state' | translate }}"
	/>
}

@if (items) {
	<ul>
		@for (item of items; track item) {
			<li>
				<wound-care-item
					data-test="woundcare-item"
					[woundCare]="item"
					(details)="details.emit(item)"
					(pictures)="pictures.emit(item)"
				/>
			</li>
		}
	</ul>
}
